var runtime = require("../../../../../../../../wix-vod-widget/build/webpack-environments/loaders/styles/myCssLoader/runtime.js");
module.exports = {"container":"_30g94","page":"_3qk27"};
module.exports._getCss = function(wrap, process){return ""+wrap+" ._30g94{display:flex;position:relative;width:100%;height:100%}"+wrap+" ._3qk27{display:flex;align-content:flex-start;flex-wrap:wrap}" };
module.exports._meta = {moduleId: module.id, order: runtime.getOrder()};

